import React from 'react';
import { MdOutlineFavoriteBorder, MdOutlineShoppingBag } from 'react-icons/md';
import { useIntl } from 'react-intl';

import { uiColors } from '../../../common/styles';
import {
    useComposition,
    useOrder,
    useNavigation,
    useAppContext,
    useModal,
    useAuth,
    useWorkspace,
    usePromotion,
} from '../../../context';
import { CHECKOUT, FAVOURITE_DRAWER } from '../../../providers/NavigationProvider';
import FramiBadge from '../FramiBadge';
import FramiIconButton from '../FramiIconButton';
import FramiTooltip from '../FramiTooltip';
import FramiHamburger from './FramiHamburger';
import { CenterWrapper, LeftWrapper, Logo, RightWrapper } from './styled';
import { LuBadgePercent } from 'react-icons/lu';
import { useCookies } from 'react-cookie';
import { usePosthog } from '../../../providers/PosthogProvider';
import { useTracking } from '../../../data/gtm';
import AddToCartWithPriceButton from '../../studio/AddToCartWithPriceButton';
import styled from 'styled-components';


const PromotionPriceTagIcon = styled.img`
    margin-left: 10px;

    @media (max-width: 350px) {
        margin-left: 0;
    }

    @media (max-width: 320px) {
        margin-left: -5px;
    }

    @media (max-width: 310px) {
        display: none;
    }
`;


const FramkyLogoNavbar = ({ showFavourite = true, showCart = true }) => {
    const { parsedComps } = useComposition();
    const { activeDrawer, openDrawer } = useNavigation();
    const { order, activeBasket, reloadOrder } = useOrder();
    const { isMobile } = useAppContext();
    const { openModal } = useModal();
    const { marketingAccepted, user } = useAuth();
    const { openNewsletterTooltip } = useWorkspace();
    const { isPromotionActive } = usePromotion();
    const [cookies, setCookie] = useCookies([]);
    const { pushEvent } = useTracking();
    const posthog = usePosthog();

    const intl = useIntl();

    const variant = posthog.getFeatureFlag('newsletter-signup') === 'test';

    const currentURL = window.location.origin;
    const urlParts = currentURL.split('.');
    const domainExtension = urlParts.length > 1 ? urlParts[urlParts.length - 1] : 'pl'; // urlParts.length === 1 is localhost:3000

    return (
        <>
            <LeftWrapper>
                <FramiHamburger />
                {/*{isPromotionActive && (*/}
                {/*    <PromotionPriceTagIcon*/}
                {/*        alt="Promotion Price Tag Icon"*/}
                {/*        rel="preload"*/}
                {/*        width={70}*/}
                {/*        height={35}*/}
                {/*        src="/assets/price_tag.png"*/}
                {/*    />*/}
                {/*)}*/}
                <Logo
                    alt="Frami Logo"
                    // rel="preload"
                    width={isPromotionActive ? 150 : 110}
                    height={50}
                    src={isPromotionActive ? "/assets/promo_logo.svg" : "/assets/logo_v2.svg"}
                    onClick={() => window.location.href = `https://framky.${domainExtension}/`}
                // style={{ paddingLeft: "21px" }}
                />
            </LeftWrapper>
            <CenterWrapper $marginLeft={isMobile ? 0 : "21px"}>
            </CenterWrapper>
            <RightWrapper $marginRight={isMobile ? 0 : "10px"}>
                {!marketingAccepted && variant && !isPromotionActive && (
                    <FramiIconButton
                        title={intl.formatMessage(
                            { id: 'studio.navbar.tooltip.newsletter.discount' },
                            { discount: 10 }
                        )}
                        size={50}
                        style={{ color: uiColors.PRIMARY, paddingLeft: 21 }}
                        icon={<LuBadgePercent />}
                        onClick={() => {
                            pushEvent('click-discount-icon',  {});
                            openModal('newsletter')
                        }}
                        dataCy="newsletter-discount"
                        showTooltip={true}
                        customTooltipStyle={{
                            backgroundColor: uiColors.PRIMARY,
                            color: uiColors.WHITE,
                            fontSize: '14px',
                            textAlign: 'center',
                            border: 'unset',
                            // padding: '14px',
                        }}
                        openTooltip={openNewsletterTooltip}
                        tooltipCloseButton={true}
                        tooltipOnClose={() => {
                            setCookie('newsletterTooltipSeen', true, { expires: 0, path: '/' });
                            pushEvent('close-discount-tooltip', {});
                        }}
                        tooltipArrow={true}
                        tooltipNotFollowCursor={true}
                    />
                )}
                {showFavourite &&
                    <section onClick={() => activeDrawer !== FAVOURITE_DRAWER && openDrawer(FAVOURITE_DRAWER)}>
                        <FramiBadge style={{ cursor: 'pointer' }} badgeContent={parsedComps?.favouriteComps?.length}>
                            <FramiIconButton
                                title={'favourite compositions'}
                                size={50}
                                disabled={activeDrawer?.includes('WELCOME')}
                                style={{ color: uiColors.PRIMARY, paddingLeft: 21 }}
                                icon={<MdOutlineFavoriteBorder />}
                                dataCy="favourite-compositions"
                            />
                        </FramiBadge>
                    </section>}
                {showCart &&
                    <FramiTooltip
                        PopperProps={{
                            disablePortal: true,
                        }}
                        title={!activeBasket ? intl.formatMessage({ id: 'studio.navbar.tooltip.basket.empty' }) : ''}
                    >
                        <section onClick={() => {
                            if (activeBasket && activeDrawer !== CHECKOUT) {
                                reloadOrder();
                                openDrawer(CHECKOUT);
                            }
                        }}>
                            <FramiBadge
                                style={{ cursor: activeBasket ? 'pointer' : '' }}
                                badgeContent={order?.status < 2 ? order?.compositions?.length : null}
                            >
                                {/*<AddToCartWithPriceButton />*/}
                                <FramiIconButton
                                    title={'basket icon'}
                                    size={50}
                                    disabled={!activeBasket}
                                    style={{ color: uiColors.PRIMARY, paddingLeft: 21 }}
                                    icon={<MdOutlineShoppingBag />}
                                />
                            </FramiBadge>
                        </section>
                    </FramiTooltip>
                }

            </RightWrapper>
        </>
    );
};

export default FramkyLogoNavbar;
